export const renewFileTypeName={
  id_type_pic_path:'Policyholder HKID',
  contract_path:'Contract',
  loss_letter_path:'No Know Loss Letter',
  microchip_copy_pic:'Pet Information',
  nm_domestic_id_type_pic:'Domestic Helper Information',
  traveler_id_type_pic:'Traveller HKID / Passport',
  pa_id_type_pic:'Insured HKID / Passport',
  student_id_type_pic:'Insured Student HKID',
  acc_parent_id_type_pic:'Accompanying Parent or Guardian HKID',
  opera:'Operator(s)',
  other_file:'Additional Documents',
  other:'Additional Documents',
  inter_file:'Internal Documents',
  ncd_proof_path:'NCB proof (e.g. Renewal Notice)',
  rgtn_pic_path:'Vehicle Registration Document',
  rgtn_with_owner_pic_path:'Vehicle Registration Document with previous owner name / Vehicle Document',
  nm_drvr_id_type_pic:'Driver‘s ID',
  nm_drvr_licence_pic:'Driving License',
  renewal_files:'Renewal Notice or 3rd Party Quotation',
  br_files:'Business Registration Certificate',
  mpf_files:'Latest 3 months Contribution Record',
  prop_pdf_path:'Insurer Application Form',
  insurer_quotation_path:'Insurer Official Quotation',
  internal_files:'Internal Documents',
  contract_file:'Contract',
  renew_file:'Renewal Notice or 3rd Party Quotation'
}
